var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstudiante3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 73.57L19.72 62.94V32.56L1.6 43.19V73.57Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.389999 44.29L1.6 44.98V73.57L0.389999 72.98V44.29Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.58 71.04L39.54 61.18V41.91L22.58 51.77V71.04Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 82.75L56.61 72.89V53.62L39.65 63.48V82.75Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 51.7L39.54 41.84L22.58 51.7L39.65 61.56L56.61 51.7Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.13 40.69C50.35 37.17 51.13 30.69 50.6 28.01C50.3952 26.7076 49.9619 25.4516 49.32 24.3C49.2309 24.0911 49.1238 23.8904 49 23.7C48.1479 22.688 47.109 21.8494 45.94 21.23C37.33 16.77 34.63 19.44 34.26 20.45C32.93 22.17 31.9 26.64 28.01 33.34L20.18 38L22.26 40.2C22.26 40.2 30.26 38.52 31.86 36.48C32.7767 35.5818 33.5794 34.5742 34.25 33.48C34.2217 34.8772 34.0947 36.2707 33.87 37.65L32.87 37.59L31.8 40.48C31.8 40.48 32.4 40.71 33.37 41.04C33.28 41.71 33.18 42.43 33.09 43.2C19.67 49.86 18.47 52.31 20.09 70.95L23.9 73.06C24.3 60.43 24.73 55.27 34.43 52C29.6 57.26 29.52 63.4 30.75 77.28L34.6 79.4C35.31 66.71 37.07 60.76 42.16 57.08C45.95 54.33 49.78 53.56 49.36 48.9C49.13 45.93 48.13 43.13 48.13 40.69Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54 47.82C27.3 55 31.8 55 33 50.05L29.54 47.82Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.61 13.27C34.26 10.71 37.74 5.07999 42.13 7.41999C46.52 9.75999 35.61 13.27 35.61 13.27Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.18 38C12.92 39.9 16.82 44.59 22.26 40.2L20.18 38Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.24 33.46C34.0767 30.2143 34.2139 26.9604 34.65 23.74",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35 16.57C34.94 18.57 35.71 20.52 38.11 20.78L37.85 22C37.65 23.13 42.77 24.58 43.49 20.51C43.8116 18.1494 44.4857 15.8504 45.49 13.69C46.05 12.39 37.89 7.24001 36.12 11.6C35.5316 13.2008 35.1551 14.8716 35 16.57Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.71 19.38C44.32 17.07 45.79 17.53 46.51 13.45C47.23 9.37 43.91 6.13 39.83 7.93C36.11 6.24 35.61 11.93 35.61 11.93C36.72 10.17 42.53 15.26 42.53 15.26C42.53 15.26 43.21 12.34 44.53 13.26C45.85 14.18 43.47 17.38 43.47 17.38C43.47 17.38 43.09 21.7 43.71 19.38Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.13 71C10.83 75.87 16.71 79.51 23.94 73.11L20.13 71Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.79 77.28C22.58 81.34 26.79 87.28 34.6 79.4L30.79 77.28Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.389999 42.53V44.29L33.18 63.16L51.3 52.54",
    fill: "#DEDEDE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.389999 42.53V44.29L33.18 63.16L51.3 52.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L51.3 82.92V52.54L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 50.78L18.52 31.91L0.389999 42.53L33.18 61.41L51.3 50.78Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L31.98 92.94V62.56L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 46.78L24.82 54.19L16.21 49.24L28.84 41.83L37.46 46.78Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.23 49.47L33.59 56.88L24.98 51.93L37.62 44.52L46.23 49.47Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.18 38C12.92 39.9 16.18 43.2 22.26 40.2L20.18 38Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.86 37.57C26 35 22.07 38.44 31.8 40.48L32.86 37.57Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28 33.34L20.18 38L22.26 40.2C22.26 40.2 30.26 38.52 31.86 36.48",
    fill: "#252525"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28 33.34L20.18 38L22.26 40.2C22.26 40.2 30.26 38.52 31.86 36.48",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 28C51.32 31.66 49.6 42.09 45.3 43C41 43.91 31.8 40.45 31.8 40.45L32.86 37.54C32.86 37.54 41.45 38.54 43.17 37.96C44.17 37.6 44.54 30.25 44.54 30.25",
    fill: "#252525"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 28C51.32 31.66 49.6 42.09 45.3 43C41 43.91 31.8 40.45 31.8 40.45L32.86 37.54C32.86 37.54 41.45 38.54 43.17 37.96C44.17 37.6 44.54 30.25 44.54 30.25",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudiante3);
export default __webpack_public_path__ + "static/media/Estudiante3.e311d1b62647dd3ff065ed95a43a85ca.svg";
export { ForwardRef as ReactComponent };